export default __webpack_public_path__ + "static/media/_DSC0442.03846e98.JPG";